export default "__VITE_ASSET__rMT_ta21__"